module.exports = require('./helpers/bundle-url').getBundleURL('jKRPl') + "arrow-grey.d7b7790f.svg";